import React from 'react';
import PropTypes from 'prop-types';

function GlyphChartLines({ fix, hideLastCircle, radius }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${radius * 2 + fix} ${radius * 2 + fix}`}
    >
      <circle cx={radius + 1} cy={radius + 1} r={radius * 0.25} />
      <circle cx={radius + 1} cy={radius + 1} r={radius * 0.5} />
      <circle cx={radius + 1} cy={radius + 1} r={radius * 0.75} />
      <circle
        cx={radius + 1}
        cy={radius + 1}
        r={radius}
        style={{ display: hideLastCircle ? 'none' : 'initial' }}
      />
      <line
        y1={radius}
        x2={radius * 2}
        y2={radius}
        style={{ transform: `translateX(${fix / 4}px)` }}
      />
      <line
        x1={radius}
        x2={radius}
        y2={radius * 2}
        style={{ transform: `translateY(${fix / 4}px)` }}
      />
      <line
        x1={radius * 0.2929}
        y1={radius * 0.2929}
        x2={radius * 1.7071}
        y2={radius * 1.7071}
        style={{ transform: `translate(${fix / 4}px, ${fix / 4}px)` }}
      />
      <line
        x1={radius * 1.7071}
        y1={radius * 0.2929}
        x2={radius * 0.2929}
        y2={radius * 1.7071}
      />
    </svg>
  );
}

GlyphChartLines.propTypes = {
  fix: PropTypes.number,
  hideLastCircle: PropTypes.bool,
  radius: PropTypes.number,
};

GlyphChartLines.defaultProps = {
  fix: 0,
  hideLastCircle: false,
  radius: 100,
};

export default GlyphChartLines;
